<script>
import { mapActions } from 'vuex';

export default {
  name: 'OpsTicketDownloadImage',
  props: {
    image: {
      type: Object,
      required: true,
    },

    showType: {
      type: String,
      required: false,
      default: 'ticket',
    },
  },

  data() {
    return {
      loading: false,
    };
  },

  methods: {
    ...mapActions('notification', ['setNotification']),
    downloadImage(image) {
      this.loading = false;
      this.$axios.post('api/v1/ops-tickets/download-image', {
        imageId: image.id,
        type: this.showType,
      }, { responseType: 'blob' })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', image.original_name);
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          const errMsg = 'There was an error processing your request';

          this.setNotification({
            message: errMsg,
            color: 'red',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<template>
  <span
    class="cursor-pointer"
    tabindex="0"
    role="button"
    @click="downloadImage(image)"
    @keydown.enter="downloadImage(image)"
    @keydown.space.prevent="downloadImage(image)"
    v-text="image.original_name"
  />
</template>

<style scoped>

</style>
